export default __webpack_public_path__ + "be0a42388b37c84ef9302ba6e5a5faff.svg";